var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pmt-flex is-row wrap pl-5 pr-5 pt-2 pb-8 gap-4"},_vm._l((_vm.link),function(item,index){return _c("v-btn",{key:index,tag:"button",class:[
      `text-capitalize text-capitalize pl-6 pr-6`,
    ],attrs:{"active-class":"active-link white--text","rounded":"","outlined":true,"to":{ path: item.path }}},[_vm._v(" "+_vm._s(_vm.$t(item.name))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }